import AOS from 'aos';

import 'owl.carousel';

import $ from 'jquery';

import 'bootstrap';

AOS.init();

$(".button-menu").click(function(){
	$(".menu-mobile").addClass("active");
});

$(".button-menu-close").click(function(){
	$(".menu-mobile").removeClass("active");
});

$(".menu-mobile li a").click(function(){
	$(".menu-mobile").removeClass("active");
});

$(document).ready(function(){
	$(window).on("scroll", function() {
		const scrollTop = $(window).scrollTop(); // quanto foi rolado
		const limite = 300; // px para acionar
	  
		if (scrollTop >= limite) {
		  $("header").addClass("active");
		} else {
		  $("header").removeClass("active");
		}
	});

	$('.owl-projetos').owlCarousel({
		loop:true,
		margin:30,
		nav:false,
		dots: true,
		responsive:{
			0:{
					items:1
			},
			600:{
					items:1
			},
			1000:{
					items:3
			}
		}
	});

	$(".button-next-home").click(function() {
		$('.owl-projetos').trigger('next.owl.carousel');
	});
	
	$(".button-prev-home").click(function() {
		$('.owl-projetos').trigger('prev.owl.carousel');
	});

	var carhome = $('.owl-home');
	carhome.owlCarousel({
		loop:true,
		margin:0,
		nav:false,
		dots: false,
		mouseDrag: false,
		navSpeed: false,
		animateOut: 'fadeOut',
		responsive:{
			0:{
					items:1
			},
			600:{
					items:1
			},
			1000:{
					items:1
			}
		}
	});
	$(".button-next-home").click(function() {
		carhome.trigger('next.owl.carousel');
	});
	
	$(".button-prev-home").click(function() {
		carhome.trigger('prev.owl.carousel');
	});
});